import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { MediaMessageTextEditorComponent } from '../../components/media-message-text-editor/media-message-text-editor.component';

@Injectable()
export class MediaTextMessageService {
  constructor(private modalController: ModalController) {}

  createTextMessage(callcard: CallCard): Promise<any> {
    return this.modalController
      .create({ component: MediaMessageTextEditorComponent, componentProps: { callcard } })
      .then(modal => modal.present());
  }
}
